export const INGREDIENT_CATEGORY_OPTIONS = [
  { label: 'Produce', value: 'produce' },
  { label: 'Dairy', value: 'dairy' },
  { label: 'Meat', value: 'meat' },
  { label: 'Pantry', value: 'pantry' },
  { label: 'Bakery', value: 'bakery' },
  { label: 'Frozen', value: 'frozen' },
  { label: 'Beverages', value: 'beverages' },
  { label: 'Dry Goods', value: 'dry_goods' },
  { label: 'Spices', value: 'spices_seasonings' },
  { label: 'Miscellaneous', value: 'miscellaneous' },
];

export const INGREDIENT_CATEGORY_LABELS = {
  produce: 'Produce',
  dairy: 'Dairy',
  meat: 'Meat',
  pantry: 'Pantry',
  bakery: 'Bakery',
  frozen: 'Frozen',
  beverages: 'Beverages',
  dry_goods: 'Dry Goods',
  spices_seasonings: 'Spices',
  miscellaneous: 'Miscellaneous',
  uncategorized: 'Uncategorized',
};

export const INGREDIENT_CATEGORY_COLORS = {
  produce: 'green',
  dairy: 'gold',
  meat: 'red',
  pantry: 'orange',
  bakery: 'magenta',
  frozen: 'cyan',
  beverages: 'blue',
  dry_goods: 'purple',
  spices_seasonings: 'volcano',
  miscellaneous: 'geekblue',
  uncategorized: 'default',
};

export const INGREDIENT_FILTER_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Meat', value: 'meat' },
  { label: 'Dairy', value: 'dairy' },
  { label: 'Produce', value: 'produce' },
  { label: 'Pantry', value: 'pantry' },
  { label: 'Bakery', value: 'bakery' },
  { label: 'Frozen', value: 'frozen' },
  { label: 'Beverages', value: 'beverages' },
  { label: 'Dry Goods', value: 'dry_goods' },
  { label: 'Spices', value: 'spices_seasonings' },
  { label: 'Miscellaneous', value: 'miscellaneous' },
  { label: 'Uncategorized', value: 'uncategorized' },
];

export const INGREDIENT_UNIT_OPTIONS = [
  { label: 'lb', value: 'lb' },
  { label: 'oz', value: 'oz' },
  { label: 'ea', value: 'ea' },
  { label: 'cup', value: 'cup' },
  { label: 'qt', value: 'qt' },
  { label: 'gal', value: 'gal' },
  { label: 'g', value: 'g' },
  { label: 'kg', value: 'kg' },
];
